import React from 'react';
import { Undo2, Redo2, Trash2, Share2, Eye, EyeOff, Loader as Loader2 } from 'lucide-react';

export default function AnnotationToolbar({
  onUndo,
  onRedo,
  onClear,
  onExport,
  canUndo,
  canRedo,
  nodeCount,
  showLines,
  onToggleLines,
  saving,
}) {
  const btnClass = (enabled) =>
    `p-2 rounded transition-colors duration-200 ${
      enabled
        ? 'text-[#a1a1aa] hover:text-white hover:bg-white/5'
        : 'text-[#3f3f46] cursor-not-allowed'
    }`;

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-1">
        <button type="button" onClick={onUndo} disabled={!canUndo} className={btnClass(canUndo)} title="Undo (Ctrl+Z)">
          <Undo2 className="w-4 h-4" />
        </button>
        <button type="button" onClick={onRedo} disabled={!canRedo} className={btnClass(canRedo)} title="Redo (Ctrl+Y)">
          <Redo2 className="w-4 h-4" />
        </button>
        <div className="w-px h-5 bg-white/10 mx-1" />
        <button type="button" onClick={onToggleLines} className={btnClass(true)} title={showLines ? 'Hide lines' : 'Show lines'}>
          {showLines ? <Eye className="w-4 h-4" /> : <EyeOff className="w-4 h-4" />}
        </button>
        <button type="button" onClick={onClear} disabled={nodeCount === 0} className={btnClass(nodeCount > 0)} title="Clear all nodes">
          <Trash2 className="w-4 h-4" />
        </button>
      </div>
      <div className="flex items-center gap-3">
        {saving && (
          <span className="flex items-center gap-1.5 text-[10px] text-[#00f5d4] font-mono">
            <Loader2 className="w-3 h-3 animate-spin" /> Saving...
          </span>
        )}
        <span className="text-[10px] text-[#8b93a7] font-mono">
          {nodeCount} node{nodeCount !== 1 ? 's' : ''}
        </span>
        <button
          type="button"
          onClick={onExport}
          disabled={nodeCount === 0}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded text-[11px] font-mono font-medium transition-all duration-200 ${
            nodeCount > 0
              ? 'bg-[#f5b400]/10 text-[#f5b400] border border-[#f5b400]/30 hover:bg-[#f5b400]/20'
              : 'bg-white/5 text-[#3f3f46] border border-white/5 cursor-not-allowed'
          }`}
          title="Export annotation as JSON payload"
        >
          <Share2 className="w-3 h-3" /> Export Count
        </button>
      </div>
    </div>
  );
}
